import { clearMyPhotos, unsentPhotoCount } from "../cashbook/photoQueue";
import { confirmDialog } from "../ui/dialog";
import { draftScope, unsavedDraftCount } from "./dailyDraft";

/**
 * Before a logout: if this user has Daily work typed on this phone and not saved, or cash book photos
 * not sent yet, ask first (the logout clears them, and they are never shown or sent for the next person
 * on the phone). True = go ahead; this user's waiting photos are then dropped from the phone.
 */
export const confirmUnsavedLogout = async (): Promise<boolean> => {
  const n = unsavedDraftCount(draftScope());
  const photos = await unsentPhotoCount();
  let go = true;
  if (n) {
    go = await confirmDialog({
      title: n === 1 ? "1 loom typed on this phone isn't saved. Log out anyway?" : `${n} looms typed on this phone aren't saved. Log out anyway?`,
      body: photos
        ? `They'll be lost, and ${photos === 1 ? "1 cash book photo" : `${photos} cash book photos`} not sent yet too. Save them first to keep them.`
        : "They'll be lost. Save them in Daily work first to keep them.",
      ok: "Log out",
      danger: true,
    });
  } else if (photos) {
    go = await confirmDialog({
      title: photos === 1 ? "1 photo not sent yet. Log out anyway?" : `${photos} photos not sent yet. Log out anyway?`,
      body: "They'll be deleted from this phone. Wait for the network to send them first.",
      ok: "Log out",
      danger: true,
    });
  }
  if (go) await clearMyPhotos();
  return go;
};
